/**
 * @generated SignedSource<<a7a38ca0fd6380d5f101310ce72a639d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_issueResults$data = {
  readonly isCappingIssueSearchResult: boolean | null | undefined;
  readonly issueSearchError: {
    readonly __typename: string;
  } | null | undefined;
  readonly totalIssueSearchResultCount: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults" | "main_issueNavigator_FullPageIssueApp" | "main_issueNavigator_Header_issueResults" | "main_issueNavigator_IssueResults_issueResults">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_issueResults";
};
export type main_issueNavigator_IssueNavigatorUI_issueResults$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_issueResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_issueResults">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_issueResults",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_issueResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_issueResults"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_FullPageIssueApp"
    },
    {
      "kind": "LinkedField",
      "name": "issueSearchError",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "totalIssueSearchResultCount"
    },
    {
      "kind": "ScalarField",
      "name": "isCappingIssueSearchResult"
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "14c34f3e137f41b9e4e6dbe27ed2ae97";

export default node;
